import React from 'react';
import TwoColumns from '~/components/TwoColumns';
import TextCard from '~/components/Dynamic/TextCard';
import Image from '~/components/Dynamic/Image';

export default function HomepageFeatures({ blok }) {
  return (
    <div className="mt-20 md:mt-28 md:mb-16">
      {blok.textCard[0] && (
        <section className="">
          <div className="container">
            <div className="flex justify-center">
              <TextCard blok={blok.textCard[0]} />
            </div>
          </div>
        </section>
      )}

      {/* Time to revenue  */}
      {blok.feature[0] && (
        <section className="mb-20 md:mb-28 md:mt-12">
          <div className="container max-w-5xl">
            <TwoColumns
              reverse
              containerClassName={blok.feature[0].containerClassName}
              textClassName={`justify-start`}
              text={<TextCard blok={blok.feature[0].textCard[0]} />}
              image={
                <div className="">
                  <Image blok={blok.feature[0].Asset[0]} />
                </div>
              }
            />
          </div>
        </section>
      )}

      {/* Works Everywhere */}
      {blok.feature[1] && (
        <section className="my-20 md:my-28 overflow-hidden">
          <div className="container relative flex flex-col-reverse max-w-5xl md:block md:space-y-12">
            <div className="flex">
              <TextCard blok={blok.feature[1].textCard[0]} />
            </div>

            <div className="flex justify-center mb-12 md:mb-0">
              <Image blok={blok.feature[1].Asset[0]} />
            </div>
          </div>
        </section>
      )}

      {/* Smooth Workflow  */}
      {blok.feature[2] && (
        <section className="my-20 md:my-28">
          <div className="container relative flex flex-col-reverse max-w-5xl md:block">
            <TwoColumns
              containerClassName={blok.feature[2].containerClassName}
              reverse
              containerClassName={`flex-col-reverse md:flex-row-reverse `}
              textClassName={`justify-start`}
              text={<TextCard blok={blok.feature[2].textCard[0]} />}
              image={<Image blok={blok.feature[2].Asset[0]} />}
              imageClassName={`!mb-12 !md:mb-0`}
              cancelSpace={true}
            />
          </div>
        </section>
      )}

      {/*Simple Finances */}
      {blok.feature[3] && (
        <section className="my-20 md:my-28">
          <div className="container relative flex flex-col-reverse max-w-5xl md:block md:space-y-12">
            <div className="flex">
              <TextCard blok={blok.feature[3].textCard[0]} />
            </div>
            <div className="flex flex-col items-center justify-center mb-12 md:flex-row md:mb-0">
              <Image blok={blok.feature[3].Asset[0]} />
              <Image blok={blok.feature[3].Asset[1]} />
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
